import React, { FC } from 'react';
import { AppBar, Toolbar } from '@mui/material';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { appViewUpdateIsDrawerOpen } from '../app/store/appViewSlice';
import Actions from './Actions';
import TitledLogo from '../components/TitledLogo';

type Props = ReturnType<typeof mapDispatchToProps>;

const AppTopBar: FC<Props> = () => {
  return (
    <AppBar
      elevation={0}
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: ({ palette }) => palette.background.paper,
        borderBottom: ({ palette }) => `1px solid ${palette.dividerLight}`,
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
          justifyContent: 'space-between',
        }}
      >
        <TitledLogo />
        <Actions />
      </Toolbar>
    </AppBar>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  toggleIsDrawerOpen: () => dispatch(appViewUpdateIsDrawerOpen()),
});

export default connect(null, mapDispatchToProps)(AppTopBar);
